import React from 'react';
import { Link } from 'react-router-dom';
import { Menu } from 'lucide-react';
import HelpGenieLogo from '../ui/HelpGenieLogo';

interface MobileNavProps {
  sidebarOpen: boolean;
  setSidebarOpen: (open: boolean) => void;
}

const MobileNav: React.FC<MobileNavProps> = ({ sidebarOpen, setSidebarOpen }) => {
  return (
    <div className="md:hidden fixed top-0 left-0 right-0 h-16 bg-white border-b border-genie-border z-50 flex items-center justify-between px-4 shadow-sm">
      <Link to="/dashboard" className="flex items-center">
        <HelpGenieLogo size={30} />
      </Link>
      <button
        onClick={() => setSidebarOpen(!sidebarOpen)}
        className="p-2 text-gray-700 hover:text-genie-blue rounded-md focus:outline-none focus:ring-2 focus:ring-genie-blue"
        aria-label={sidebarOpen ? 'Close navigation menu' : 'Open navigation menu'}
      >
        <Menu size={28} />
      </button>
    </div>
  );
};

export default MobileNav;
